export const IconDoubleTag = (props) => {
  return (
    <svg
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.1982 21.2353L4.54004 12.5771V14.3459C4.54004 14.8147 4.72576 15.2657 5.06183 15.5929L11.9512 22.4823C12.641 23.1721 13.7642 23.1721 14.454 22.4823L19.9461 16.9902C20.6359 16.3004 20.6359 15.1772 19.9461 14.4874L13.1982 21.2353Z"
        fill="currentColor"
      />
      <path
        d="M11.9512 18.0607C12.2961 18.4056 12.7472 18.5825 13.1982 18.5825C13.6492 18.5825 14.1003 18.4056 14.4452 18.0607L19.9372 12.5687C20.6271 11.8788 20.6271 10.7557 19.9372 10.0658L13.0479 3.17646C12.7206 2.84923 12.2696 2.66351 11.8009 2.66351H6.30882C5.33599 2.66351 4.54004 3.45946 4.54004 4.43229V9.92434C4.54004 10.3931 4.72576 10.8441 5.06183 11.1713L11.9512 18.0607ZM6.30882 4.43229H11.8009L18.6902 11.3217L13.1982 16.8137L6.30882 9.92434V4.43229Z"
        fill="currentColor"
      />
      <path
        d="M8.29884 7.52756C8.90939 7.52756 9.40433 7.03262 9.40433 6.42207C9.40433 5.81153 8.90939 5.31659 8.29884 5.31659C7.6883 5.31659 7.19336 5.81153 7.19336 6.42207C7.19336 7.03262 7.6883 7.52756 8.29884 7.52756Z"
        fill="currentColor"
      />
    </svg>
  );
};
